/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-undef */
import { classNames } from 'shared/lib/classNames/classNames';
import React, { ReactNode, useEffect, useState } from 'react';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { Title, TitleSize } from 'shared/ui/Title/Title';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { AppLink } from 'shared/ui/AppLink/AppLink';
import Approved from 'shared/assets/icons/approved.svg';
import cls from './ServiceCard.module.scss';

interface ServiceCardProps {
    name: string,
    description?: string,
    uniqueKey: string,
    isIssued?: any,
    img?: any,
    className?: string,
}

export const ServiceCard = ({
    name,
    description,
    uniqueKey,
    img,
    isIssued,
    className
}: ServiceCardProps) => {
    // console.log(isIssued.status, 'isIssued');
    const isCredit = sessionStorage.getItem('credit') === '1' ? true : false;
    console.log(uniqueKey === 'credit10' ? isCredit : isIssued.status, 'isCredit');
    return (
        <div className={classNames(cls.card, { [cls.hasBackgroundImage]: uniqueKey === 'nsj' })}>
            <div className={cls.content}>
                <Title className={cls.title} color="#000000" size={TitleSize.title_20}>{name}</Title>
                <Text className={cls.title} color="#000000" size={TextSize.text_14}>{description}</Text>
            </div>
            <div className={classNames(cls.imgBox, { [cls.hidden]: uniqueKey === 'nsj' })}>
                <img src={img} alt="" className={cls.img} />
            </div>
            <div className={cls.buttonWrapper}>
                <AppLink to={`/finance/policy/${uniqueKey}`}>
                    <Button className={cls.button} icon={(uniqueKey === 'credit10' ? isCredit : isIssued.status) && <Approved />} theme={ButtonTheme.TAB}>
                        {(uniqueKey === 'credit10' ? isCredit : isIssued.status) ? 'Оформлен' : 'Оформить'}
                    </Button>
                </AppLink>
            </div>
        </div>
    );
};
